import { render, staticRenderFns } from "./AdminPois.vue?vue&type=template&id=768236d0&scoped=true"
import script from "./AdminPois.vue?vue&type=script&lang=js"
export * from "./AdminPois.vue?vue&type=script&lang=js"
import style0 from "./AdminPois.vue?vue&type=style&index=0&id=768236d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768236d0",
  null
  
)

export default component.exports